exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-tint{display:block;position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;opacity:0;visibility:hidden;background-color:#333}adp-tint,adp-tint.opened{transition:opacity .3s ease,visibility .3s ease}adp-tint.opened{opacity:.6;visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpTint/adpTint.less
// module id = 612
// module chunks = 0